import axios from "axios";
import { toast } from "react-toastify";
import { ERROR_TYPES } from "../context/reducers/errorReducers";
import { CATALOG_TYPES } from "../context/reducers/catalogReducers";
import { DateTime } from "luxon";
import queryString from "query-string";
import { VEHICLE_TYPES } from "../context/reducers/vehicleReducers";

var messageBuffer = "";

var tools = {
  setAuthToken: (token) => {
    if (token) {
      // Apply to every request
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
      // Delete Auth header
      delete axios.defaults.headers.common["Authorization"];
    }
  },
  findIn(array, key, value) {
    if (!array) return {};
    return array.find((a) => a[key] == value) || {};
  },
  isEmpty: (value) => {
    return (
      value === undefined ||
      value === null ||
      (typeof value === "object" && Object.keys(value).length === 0) ||
      (typeof value === "string" && value.trim().length === 0)
    );
  },
  getSearchString: (search) => {
    //convert json object to query string
    //the json object can contain arrays

    var str = [];
    for (var p in search) {
      if (search.hasOwnProperty(p)) {
        if (search[p] != null && search[p] != "") {
          if (Array.isArray(search[p])) {
            search[p].forEach((s) => {
              str.push(encodeURIComponent(p) + "[]=" + encodeURIComponent(s));
            });
          } else {
            str.push(
              encodeURIComponent(p) + "=" + encodeURIComponent(search[p]),
            );
          }
        }
      }
    }

    return `?${str.join("&")}`;
  },

  truncate: (text, n) => {
    return text.length > n ? text.substr(0, n - 1) + "..." : text;
  },
  beautiFyNumber: (x) => {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return parts.join(".");
  },
  inputChange: (e, type, dispatch) => {
    var key = e.target.name;
    var value = e.target.value;
    if (e.target.type == "checkbox") value = e.target.checked ? true : false;
    dispatch({
      type,
      payload: {
        key,
        value,
      },
    });
  },

  filterError: (dispatch, error, loadToClose) => {
    dispatch({ type: loadToClose, payload: false });
    dispatch({ type: ERROR_TYPES.GET_ERRORS, payload: error.errors || {} });

    if (typeof error === "string" && error === "Unauthorized") {
      alert("Votre session a expiré. Veuillez vous reconnecter");
      //window.location.href = "/login";
      // toastr.confirm("Votre session a expiré. Veuillez vous reconnecter", toastrConfirmOptions)
      toast.error("Veuillez vous reconnecter");
    } else if (error.message) {
      console.log(error);
      toast.error("Erreur " + error.message);
    }
  },

  filterAlert: (type, message) => {
    if (message != messageBuffer) {
      switch (type) {
        case "success":
          toast.success(message);
          break;
        case "info":
          toast.info(message);
          break;

        default:
          break;
      }
    }
    messageBuffer = message;
    setTimeout(() => {
      messageBuffer = "";
    }, 2000);
  },
  formatDate: (date) => {
    if (!date) return "";
    return DateTime.fromISO(date).toFormat("dd/MM/yyyy");
  },

  /**
   * Formate un numéro d'immatriculation français
   * @param {string} immat - Le numéro d'immatriculation à formater
   * @returns {string} Le numéro formaté avec des espaces
   */
  formatImmat: (immat) => {
    if (!immat) return "";

    // Supprime tous les espaces existants et met en majuscules
    const cleaned = immat.replace(/\s+/g, "").toUpperCase();

    // Vérifie le format ancien (1234 AB 97) ou nouveau (AB-123-CD)
    const oldFormat = /^\d{1,4}[A-Z]{2,3}\d{2,3}$/;
    const newFormat = /^[A-Z]{2}-?\d{3}-?[A-Z]{2}$/;

    if (oldFormat.test(cleaned)) {
      // Ancien format : 1234 AB 97
      // On prend les 1-4 premiers chiffres, puis 2-3 lettres, puis 2-3 chiffres
      const match = cleaned.match(/^(\d{1,4})([A-Z]{2,3})(\d{2,3})$/);
      if (match) {
        return `${match[1]} ${match[2]} ${match[3]}`;
      }
    } else if (newFormat.test(cleaned.replace(/-/g, ""))) {
      // Nouveau format : AB-123-CD
      const match = cleaned
        .replace(/-/g, "")
        .match(/^([A-Z]{2})(\d{3})([A-Z]{2})$/);
      if (match) {
        return `${match[1]} ${match[2]} ${match[3]}`;
      }
    }

    // Si aucun format reconnu, on retourne la valeur nettoyée
    return cleaned;
  },
  formatPercentage: (value) => {
    if (!value && value !== 0) return "---";
    return `${Number(value * 100).toFixed(2)} %`;
  },
  formatCurrency: (value) => {
    if (!value && value !== 0) return "---";
    return `${Number(value).toFixed(2)} €`;
  },
  sortQuotations: (fields, dataArray) => {
    dataArray = dataArray.sort((a, b) => {
      if (fields.includes("brand")) {
        var brandA = a.vehicle.brand.uuid;
        var brandB = b.vehicle.brand.uuid;
        if (brandA < brandB) return -1;
        if (brandA > brandB) return 1;
      }
      if (fields.includes("brandModel")) {
        var brandModelA = a.vehicle.brandModel.uuid;
        var brandModelB = b.vehicle.brandModel.uuid;
        if (brandModelA < brandModelB) return -1;
        if (brandModelA > brandModelB) return 1;
      }
      if (fields.includes("finish")) {
        var finishA = a.vehicle.finish;
        var finishB = b.vehicle.finish;
        if (finishA < finishB) return -1;
        if (finishA > finishB) return 1;
      }
      if (fields.includes("rollingLaw")) {
        var rlA = a.dur + a.km;
        var rlB = b.dur + b.km;
        if (rlA < rlB) return -1;
        if (rlA > rlB) return 1;
      }
      return 0;
    });

    return dataArray;
  },
  filterQuotations: (filters, dataArray) => {
    var showKeys = [];
    dataArray.forEach((d, k) => {
      var incl = true;
      if (filters.brand != "") {
        if (d.vehicle.brand.name.toLowerCase().includes(filters.brand)) {
          incl = true;
        } else {
          incl = false;
        }
      }
      if (filters.brandModel != "") {
        if (
          d.vehicle.brandModel.name.toLowerCase().includes(filters.brandModel)
        ) {
          incl = incl != false ? true : false;
        } else {
          incl = false;
        }
      }
      if (filters.finish != "") {
        if (
          d.vehicle.brandModelFinish.name.toLowerCase().includes(filters.finish)
        ) {
          incl = incl != false ? true : false;
        } else {
          incl = false;
        }
      }
      if (filters.duration != "") {
        if (d.dur.toString().includes(filters.duration)) {
          incl = incl != false ? true : false;
        } else {
          incl = false;
        }
      }
      if (filters.km != "") {
        if (d.km.toString().includes(filters.km)) {
          incl = incl != false ? true : false;
        } else {
          incl = false;
        }
      }
      if (filters.status != "") {
        if (d.status.id.toString().includes(filters.status)) {
          incl = incl != false ? true : false;
        } else {
          incl = false;
        }
      }

      if (
        filters.km == "" &&
        filters.duration == "" &&
        filters.brand == "" &&
        filters.brandModel == "" &&
        filters.finish == "" &&
        filters.status == ""
      ) {
        incl = true;
      }
      if (incl) {
        showKeys.push(k);
      }
    });
    var hideKeys = [];
    dataArray.forEach((d, k) => {
      if (!showKeys.includes(k)) hideKeys.push(k);
    });

    return hideKeys;
  },
  getPercentOf(a, b) {
    var c = (parseFloat(a) * parseFloat(b)) / 100;
    return parseFloat(c);
  },
  getFullname: (user) => {
    if (!user) return "";
    return user.firstname + " " + user.lastname;
  },

  recalculateDiscount(
    TVA,
    TVA_INVERT,
    changedDiscount,
    value,
    dispatch,
    catalogData,
    rmOptions,
  ) {
    var discountPct = 0;
    var discount = 0;
    var discountTTC = 0;
    value = parseFloat(value);
    if (changedDiscount == "discountPct") {
      discountPct = value;
      var discount =
        Math.round(
          ((parseFloat(discountPct) *
            (parseFloat(catalogData.priceHT) + rmOptions)) /
            100) *
            100,
        ) / 100;
      var discountTTC =
        Math.round(
          (discount + discount * (catalogData.type == 1 ? TVA : 0)) * 100,
        ) / 100;
    }
    if (changedDiscount == "discount") {
      discount = value;
      discountPct =
        Math.round(
          (parseFloat(discount) / (catalogData.priceTTC + rmOptions)) *
            100 *
            100,
        ) / 100;

      discountTTC =
        Math.round(
          (parseFloat(discount) +
            parseFloat(discount) * (catalogData.type == 1 ? TVA : 0)) *
            100,
        ) / 100;
    }
    if (changedDiscount == "discountTTC") {
      discountTTC = value;
      discount =
        Math.round(
          (parseFloat(discountTTC) / (catalogData.type == 1 ? TVA_INVERT : 1)) *
            100,
        ) / 100;
      discountPct =
        Math.round(
          (discount / (parseFloat(catalogData.priceHT) + rmOptions)) *
            100 *
            100,
        ) / 100;
    }
    if (changedDiscount == "priceHT") {
      discountPct = parseFloat(catalogData.discountPct);
      discount =
        Math.round(
          ((parseFloat(discountPct) * (value + rmOptions)) / 100) * 100,
        ) / 100;
      discountTTC =
        Math.round(
          (parseFloat(discount) +
            parseFloat(discount) * (catalogData.type == 1 ? TVA : 0)) *
            100,
        ) / 100;
    }
    if (changedDiscount == "priceTTC") {
      discountPct = parseFloat(catalogData.discountPct);

      var discount =
        Math.round(
          ((parseFloat(catalogData.discountPct) *
            (parseFloat(value) + rmOptions)) /
            100) *
            100,
        ) / 100;
      discountTTC =
        Math.round(
          (parseFloat(discount) +
            parseFloat(discount) * (catalogData.type == 1 ? TVA : 0)) *
            100,
        ) / 100;
    }

    dispatch({
      type: CATALOG_TYPES.UPDATE_CATALOG_DATA,
      payload: {
        key: "discountPct",
        value: discountPct,
      },
    });
    dispatch({
      type: CATALOG_TYPES.UPDATE_CATALOG_DATA,
      payload: {
        key: "discount",
        value: discount,
      },
    });
    dispatch({
      type: CATALOG_TYPES.UPDATE_CATALOG_DATA,
      payload: {
        key: "discountTTC",
        value: discountTTC,
      },
    });
  },
  recalculateVehicleDiscount(
    TVA,
    TVA_INVERT,
    changedDiscount,
    value,
    dispatch,
    vehicleData,
    rmOptions,
  ) {
    var discountPct = 0;
    var discount = 0;
    var discountTTC = 0;
    value = parseFloat(value);
    if (changedDiscount == "discountPct") {
      discountPct = value;
      var discount =
        Math.round(
          ((parseFloat(discountPct) *
            (parseFloat(vehicleData.priceHT) + rmOptions)) /
            100) *
            100,
        ) / 100;
      var discountTTC =
        Math.round(
          (discount + discount * (vehicleData.type == 1 ? TVA : 0)) * 100,
        ) / 100;
    }
    if (changedDiscount == "discount") {
      discount = value;
      discountPct =
        Math.round(
          (parseFloat(discount) / (vehicleData.priceTTC + rmOptions)) *
            100 *
            100,
        ) / 100;

      discountTTC =
        Math.round(
          (parseFloat(discount) +
            parseFloat(discount) * (vehicleData.type == 1 ? TVA : 0)) *
            100,
        ) / 100;
    }
    if (changedDiscount == "discountTTC") {
      discountTTC = value;
      discount =
        Math.round(
          (parseFloat(discountTTC) / (vehicleData.type == 1 ? TVA_INVERT : 1)) *
            100,
        ) / 100;
      discountPct =
        Math.round(
          (discount / (parseFloat(vehicleData.priceHT) + rmOptions)) *
            100 *
            100,
        ) / 100;
    }
    if (changedDiscount == "priceHT") {
      discountPct = parseFloat(vehicleData.discountPct);
      discount =
        Math.round(
          ((parseFloat(discountPct) * (value + rmOptions)) / 100) * 100,
        ) / 100;
      discountTTC =
        Math.round(
          (parseFloat(discount) +
            parseFloat(discount) * (vehicleData.type == 1 ? TVA : 0)) *
            100,
        ) / 100;
    }
    if (changedDiscount == "priceTTC") {
      discountPct = parseFloat(vehicleData.discountPct);

      var discount =
        Math.round(
          ((parseFloat(vehicleData.discountPct) *
            (parseFloat(value) + rmOptions)) /
            100) *
            100,
        ) / 100;
      discountTTC =
        Math.round(
          (parseFloat(discount) +
            parseFloat(discount) * (vehicleData.type == 1 ? TVA : 0)) *
            100,
        ) / 100;
    }

    dispatch({
      type: VEHICLE_TYPES.UPDATE_VEHICLE_DATA,
      payload: {
        key: "discountPct",
        value: discountPct,
      },
    });
    dispatch({
      type: VEHICLE_TYPES.UPDATE_VEHICLE_DATA,
      payload: {
        key: "discount",
        value: discount,
      },
    });
    dispatch({
      type: VEHICLE_TYPES.UPDATE_VEHICLE_DATA,
      payload: {
        key: "discountTTC",
        value: discountTTC,
      },
    });
  },
  updateQueryParams: (history, location, params) => {
    const queryObj = queryString.parse(location.search, {
      arrayFormat: "bracket",
    });
    const query =
      "?" +
      queryString.stringify(
        { ...queryObj, ...params },
        { arrayFormat: "bracket" },
      );
    history.push(query);
  },
  getQuotationStatusColor: (status) => {
    switch (status) {
      case 1:
        return "secondary";
      case 2:
        return "primary";
      case 3:
        return "success";
      default:
        return "";
    }
  },
  getStringPlural: (txt, isPlural) => {
    return isPlural ? txt + "s" : txt;
  },
  beautiFyNumberformatNumberSpaces: (num) => {
    //if num is not a number or string containing a number return empty string
    if (isNaN(num)) return "";
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  },
  /**
   * Retourne le catalog HITECH correspondant à une zone géographique
   * @param {string} geographicZoneName - Le nom de la zone géographique
   * @returns {string} Le catalog HITECH ("reunion", "mayotte", ou la valeur par défaut)
   */
  getHitechCatalogFromGeographicZone: (catalog) => {
    if (catalog.geographicZone?.name) {
      switch (catalog.geographicZone.name) {
        case "La Réunion":
          return "reunion";
        case "Mayotte":
          return "mayotte";
        default:
          return null;
      }
    } else if (catalog.geographic_zone) {
      switch (catalog.geographic_zone) {
        case 1:
          return "reunion";
        case 2:
          return "mayotte";
        default:
          return null;
      }
    }
    return null;
  },
};

export default tools;
